
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"14","height":"18","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M.047 18V0h6.181c2.234 0 3.977.414 5.23 1.242 1.252.829 1.879 2.063 1.879 3.703 0 .857-.202 1.62-.606 2.287-.404.668-1.026 1.17-1.867 1.508 1.055.24 1.834.72 2.337 1.44.502.722.754 1.552.754 2.492 0 1.755-.59 3.082-1.768 3.98C11.008 17.551 9.32 18 7.118 18H.047zm4.19-10.496h2.078c.948-.016 1.656-.2 2.126-.55.47-.35.705-.863.705-1.54 0-.766-.24-1.324-.717-1.674-.478-.35-1.212-.526-2.2-.526H4.237v4.29zm0 2.77v4.512h2.881c.89 0 1.558-.175 2.003-.526.445-.35.668-.888.668-1.613 0-.783-.192-1.374-.575-1.774-.383-.4-1.003-.6-1.86-.6H4.237z","fill":"#282828"}})])
          )
        }
      }
    